import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X, ArrowRight } from "lucide-react";
import api from "../lib/api";

const DISMISS_KEY = "nexari_subscribe_banner_dismissed";

export default function SubscribeBanner({ role }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Only show for billable roles
    if (!["agency", "family", "subcontractor"].includes(role)) return;
    // Check dismissal (re-shows next session anyway since this is sessionStorage)
    try {
      if (sessionStorage.getItem(DISMISS_KEY) === "1") return;
    } catch (e) { /* noop */ }
    api.get("/billing/subscription").then((r) => {
      if (!r.data.active) setShow(true);
    }).catch(() => {/* silent */});
  }, [role]);

  if (!show) return null;

  function dismiss() {
    try { sessionStorage.setItem(DISMISS_KEY, "1"); } catch (e) { /* noop */ }
    setShow(false);
  }

  return (
    <div
      data-testid="subscribe-banner"
      className="mb-6 bg-gradient-to-r from-[#2E5C50] to-[#22463D] text-white rounded-xl p-4 flex items-center gap-4 shadow-sm"
    >
      <div className="w-10 h-10 bg-white/15 rounded-md flex items-center justify-center flex-shrink-0">
        <Sparkles className="w-5 h-5" strokeWidth={1.5} />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-heading font-semibold text-base leading-tight">Try Nexari free for 7 days — pick a plan to unlock everything</h3>
        <p className="mt-1 text-sm text-white/80 leading-snug">
          Document AI, full compliance scoring, EVV, priority support. No charge until day 8 — cancel anytime.
        </p>
      </div>
      <Link
        to="/pricing"
        data-testid="subscribe-banner-cta"
        className="flex items-center gap-1.5 bg-white text-[#2E5C50] hover:bg-[#F0EDE8] transition-colors duration-200 rounded-md px-4 py-2 text-sm font-semibold whitespace-nowrap"
      >
        See plans <ArrowRight className="w-3.5 h-3.5" />
      </Link>
      <button
        data-testid="subscribe-banner-dismiss"
        onClick={dismiss}
        aria-label="Dismiss"
        className="text-white/70 hover:text-white transition-colors flex-shrink-0"
      >
        <X className="w-4 h-4" strokeWidth={1.5} />
      </button>
    </div>
  );
}
